module.exports = __webpack_public_path__ + "img/image_online03@2x.5283123d.png";